var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var PosData = require("./../../abstract/posData.js");
var EllipseData = require("./../../svg/ellipseData.js");

var ViaData = function(net, pos, endsize, shape, startLayer, endLayer){
    var self = this;

    this.makeObservableTreeNode();

    this.addPos(pos); // TODO: do we need angle since we have shape?

    this.endsize = this.value("endsize", true); // resulting diameter of drill after copper is added
    this.shape = this.value("shape", true);
    this.net = this.value("net", false);

    this.startLayer = this.value("startLayer", true);
    this.endLayer = this.value("endLayer", true);

    this.segmentedGeometry = this.cachedFunction("segmentedGeometry",
        this._getSegmentedGeometry,
        [this.pos, this.shape, this.endsize]
    );

    this.bufferedSegmentedGeometry = this.cachedFunction("bufferedSegmentedGeometry",
        this._getBufferedSegmentedGeometry,
        [this.segmentedGeometry]
    );
    this.segmentedHoleGeometry = this.cachedFunction("segmentedHoleGeometry",
        function(precision){
            var rx = self.endsize()/2;
            var poly = new lib_geometry.Path()
                .moveTo(self.pos().x, self.pos().y)
                .fromEllipse(rx, rx)
                .toPolygon(precision);
            return poly;
        },
        [this.pos, this.endsize]
    );

    this.outlineGeometry = this.segmentedGeometry;


    this.onInit("init", this._initialize);

    if(net != undefined) this.net(net);
    if(endsize != undefined) this.endsize(endsize);
    if(shape != undefined) this.shape(shape);
    if(startLayer != undefined) this.startLayer(startLayer);
    if(endLayer != undefined) this.endLayer(endLayer);
};
lib_core.mixin(ViaData, lib_core.ObservableTreeNode, PosData);
lib_core.JsonParser.registerClass(ViaData, "Via");

module.exports = ViaData;

ViaData.prototype._initialize = function(){
    var self = this;

    this.boundingBox = this.cachedFunction("boundingBox",
        function () { 
            return self.segmentedGeometry(self.parent().geometryPrecision()).getBB(); 
        },
        [this.segmentedGeometry]
    );

    this.mesh = this.cachedFunction("mesh",
        function (precision) {
            var thickness = self.parent().boardThickness + self.parent().copperThickness;
            var hole = self.segmentedHoleGeometry(precision);

            var topGeom = lib_geometry.Union([self.outlineGeometry(precision)], [hole]);
            var topPad = (new lib_geometry.TriangleMesh()).fromPolygon(topGeom, this.parent().copperThickness);
            
            var middleGeom = hole.close().toOutlineGeometry(this.parent().copperThickness, this.parent().segmentPrecision3d);
            
            var toplayer = self.parent().getRealLayer( self.startLayer(), self.parent().number_of_layers());
            var topdeptPercent = toplayer / (self.parent().number_of_layers() - 1);
            var trans = thickness * topdeptPercent;

            var bottomLayer = self.parent().getRealLayer( self.endLayer(), self.parent().number_of_layers());
            var botdeptPercent = bottomLayer / (self.parent().number_of_layers() - 1);
            var length = (thickness * botdeptPercent) - trans + self.parent().copperThickness;

            var middleMesh = (new lib_geometry.TriangleMesh()).fromPolygon(middleGeom, length);

            var bottomPad = topPad.clone().translate(0, 0, length - this.parent().copperThickness);

            var mesh = topPad.mergeMesh(bottomPad.mergeMesh(middleMesh));
            mesh.translate(0, 0, trans);
            return mesh;
        },
        [this.outlineGeometry, this.parent().number_of_layers, this.startLayer, this.endLayer,
        this.segmentedHoleGeometry]
    );
}

ViaData.prototype._getGeometry = function () {
    var poly = this.shape().geometry();
    console.assert(poly instanceof lib_geometry.Polygon);
    poly = poly.translate(this.pos());
    // poly = poly.rotate(this.angle(), this.pos());
    return poly;
};

ViaData.prototype._getSegmentedGeometry = function (precision) {
    var poly = this.shape().segmentedGeometry(precision);
    poly = poly.translate(this.pos());
    // poly = poly.rotate(this.angle(), this.pos());
    return poly;
};

ViaData.prototype._getBufferedSegmentedGeometry = function (precision, layerIndex, layerType, bufferSize) {
    return this.segmentedGeometry(precision, layerIndex, layerType).buffer(bufferSize);
};

ViaData.prototype.getSegmentedHoleGeometry = function (precision) {
    return this.segmentedHoleGeometry(precision);
};

ViaData.prototype.getLayers = function () {
    var layers = new lib_core.Collections.HashSet();

    var startStackIndex = this.parent().convertInternalToStackIndex(this.startLayer());
    var endStackIndex = this.parent().convertInternalToStackIndex(this.endLayer());

    var start, end;
    if(startStackIndex < endStackIndex) {
        start = startStackIndex;
        end = endStackIndex;
    } else {
        start = endStackIndex;
        end = startStackIndex;
    }

    for(var i=start; i<=end; i++) {
        layers.add(this.parent().layerStack().get(i));
    }

    return layers;
};

ViaData.prototype.getConnectedSegments = function () {
    return this.parent().vtxConSegMap.get(this) || new lib_core.Collections.HashSet();
};

